import { render, staticRenderFns } from "./ProblemaTab.vue?vue&type=template&id=a3171924"
import script from "./ProblemaTab.vue?vue&type=script&lang=js"
export * from "./ProblemaTab.vue?vue&type=script&lang=js"
import style0 from "./ProblemaTab.vue?vue&type=style&index=0&id=a3171924&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports